
const COMPONENT_NAME = "z-dom-ping" ;

export default function register(){
    class TabDomPing extends HTMLElement {
        constructor() {
            super();
        }
        
        connectedCallback() {
            let eventName = "connected" ;
            if(this.hasAttribute("z-event-connected")){
                eventName = this.getAttribute("z-event-connected") ;
            }
            // console.log("PING CONNECTED "+eventName) ;
            this.dispatchEvent(new Event(eventName, {bubbles: true}));
        }
    }
    customElements.define(COMPONENT_NAME, TabDomPing);
}
